module.exports = __webpack_public_path__ + "static/img/activity-20240628.8c22bb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-20240628.png
// module id = 48Oo
// module chunks = 0